'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CSV = (_temp = _class = function (_SvgIcon) {
  _inherits(CSV, _SvgIcon);

  function CSV() {
    _classCallCheck(this, CSV);

    return _possibleConstructorReturn(this, (CSV.__proto__ || Object.getPrototypeOf(CSV)).apply(this, arguments));
  }

  _createClass(CSV, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'defs',
            null,
            _react2['default'].createElement('path', { id: 'a', d: 'M0 0h38v43H0z' }),
            _react2['default'].createElement('path', { id: 'c', d: 'M0 43h40.232V0H0z' })
          ),
          _react2['default'].createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2['default'].createElement('path', { d: 'M0 0h64v64H0z' }),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(12.5 10)' },
              _react2['default'].createElement(
                'mask',
                { id: 'b', fill: '#fff' },
                _react2['default'].createElement('use', { xlinkHref: '#a' })
              ),
              _react2['default'].createElement('path', {
                fill: '#E0E0E0',
                d: 'M2.19 0h33.62C37.02 0 38 .98 38 2.19v38.62A2.19 2.19 0 0 1 35.81 43H2.19A2.19 2.19 0 0 1 0 40.81V2.19C0 .98.981 0 2.19 0',
                mask: 'url(#b)'
              }),
              _react2['default'].createElement('path', {
                fill: '#FFF',
                d: 'M4.934 5h28.132C34.134 5 35 5.866 35 6.934v30.132A1.934 1.934 0 0 1 33.066 39H4.934A1.934 1.934 0 0 1 3 37.066V6.934C3 5.866 3.866 5 4.934 5'
              }),
              _react2['default'].createElement(
                'mask',
                { id: 'd', fill: '#fff' },
                _react2['default'].createElement('use', { xlinkHref: '#c' })
              ),
              _react2['default'].createElement('path', {
                fill: '#A9A9A9',
                d: 'M7.125 15.013h6.487v-3.708H7.125zM7.125 21.518h6.487v-3.707H7.125zM7.125 28.024h6.487v-3.707H7.125zM7.125 34.529h6.487v-3.707H7.125zM15.75 34.529h6.487v-3.707H15.75zM24.374 34.529h6.487v-3.707h-6.487z',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#A9A9A9',
                d: 'M7.125 24.317v3.707h6.487v-3.707M15.75 28.024h6.487v-3.707H15.75zM24.374 28.024h6.487v-3.707h-6.487zM15.75 21.518h6.487v-3.707H15.75zM24.374 21.518h6.487v-3.707h-6.487zM15.75 15.013h6.487v-3.708H15.75zM24.374 15.013h6.487v-3.708h-6.487z',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#E0E0E0',
                d: 'M38.93 27.515H19.665a1.31 1.31 0 0 0-1.301 1.311v7.291a1.311 1.311 0 0 0 1.3 1.303H38.93a1.311 1.311 0 0 0 1.302-1.31v-7.293a1.309 1.309 0 0 0-1.302-1.302',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#8FC056',
                d: 'M38.43 27.515H19.167a1.31 1.31 0 0 0-1.301 1.311v7.291a1.31 1.31 0 0 0 1.3 1.303h19.266a1.311 1.311 0 0 0 1.302-1.31v-7.293a1.31 1.31 0 0 0-1.302-1.302',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#FFF',
                d: 'M20.479 32.372c0-1.84 1.059-2.914 2.738-2.914 1.425 0 2.508.918 2.55 2.25H24.39c-.07-.664-.543-1.102-1.172-1.102-.781 0-1.277.668-1.277 1.762 0 1.106.491 1.774 1.28 1.774.63 0 1.087-.415 1.177-1.075h1.379c-.067 1.34-1.107 2.223-2.56 2.223-1.687 0-2.738-1.074-2.738-2.918M27.756 33.532c.066.402.5.637 1.05.637.559 0 .923-.25.923-.594 0-.313-.243-.473-.911-.602l-.578-.109c-1.125-.211-1.707-.762-1.707-1.621 0-1.086.942-1.785 2.239-1.785 1.418 0 2.254.695 2.269 1.769h-1.332c-.023-.406-.406-.648-.926-.648s-.828.234-.828.566c0 .297.258.461.87.578l.579.11c1.204.23 1.75.719 1.75 1.605 0 1.133-.886 1.852-2.375 1.852-1.406 0-2.335-.649-2.355-1.758h1.332zM33.459 35.192l-1.798-5.637h1.63l1.086 4.235h.03l1.083-4.235h1.57l-1.797 5.637z',
                mask: 'url(#d)'
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return CSV;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = CSV;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/CSV.js
// module id = 1361
// module chunks = 32